/**
 * Created by AlexanderC on 5/22/15.
 *
 * Bootstrap file loaded by npm as main
 */

'use strict';

var _Validation = require('./Validation');

module.exports = _Validation.Validation;


//////////////////
// WEBPACK FOOTER
// ../~/deep-validation/lib.compiled/bootstrap.js
// module id = 466
// module chunks = 0